import React from "react"
import axios from "axios"
import { NavLink } from "react-router-dom"
import { useSelector } from "react-redux"
import { getUser } from "~/store"
import IconArrowRight from "~/components/Icons/IconArrowRight"
import "./SettingsMenu.scss"
import classNames from "classnames"

function SettingsMenu() {
  const user = useSelector(getUser)

  const logUserOut = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const token = (
      document.querySelector("[name=csrf-token]") as HTMLMetaElement
    )?.content

    axios
      .delete("/users/sign_out", { headers: { "X-CSRF-TOKEN": token } })
      .then(() => {
        window.location.reload()
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <nav className="SettingsMenu">
      <NavLink
        to="/settings/profile"
        className={({ isActive }) =>
          classNames("SettingsMenu__link", {
            "SettingsMenu__link--selected": isActive,
          })
        }
      >
        Profile
        <IconArrowRight />
      </NavLink>

      {user?.organisation_name && (
        <>
          <NavLink
            to="/settings/organisation"
            className={({ isActive }) =>
              classNames("SettingsMenu__link", {
                "SettingsMenu__link--selected": isActive,
              })
            }
          >
            Organisation
            <IconArrowRight />
          </NavLink>

          <NavLink
            to="/settings/users"
            className={({ isActive }) =>
              classNames("SettingsMenu__link", {
                "SettingsMenu__link--selected": isActive,
              })
            }
          >
            Users
            <IconArrowRight />
          </NavLink>
        </>
      )}

      <NavLink to="/" className="SettingsMenu__link" onClick={logUserOut}>
        Log out
      </NavLink>
    </nav>
  )
}

export default SettingsMenu
